export default __webpack_public_path__ + "static/media/02-Bannerregistro_PlaneacionDeRuta.86f7a208.jpg";